import { WrappedFormUtils } from 'antd/lib/form/Form'

export function getValidatedFormValues<T = any>(form: WrappedFormUtils): Promise<T> {
  return new Promise((resolve, reject) => {
    form.validateFields((err, values) => {
      if (!err) {
        resolve(values)
      } else {
        reject(err)
      }
    })
  })
}
